module.exports = __webpack_public_path__ + "media/members/add_golfers_manually-1d1538c7.png";